import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'physicalhazard',
  templateUrl: './physicalhazard.component.html',
  styleUrls: ['./physicalhazard.component.css']
})
export class PhysicalhazardComponent implements OnInit {

  constructor() { }

  checkAllPhysicalHazard = false;

  physicalState: any;
  physicalStateChecked = false;

  combustibleDusts: any;
  combustibleDustsChecked = false;

  corrosiveToMetals: any;
  corrosiveToMetalsChecked = false;

  flammableAerosols: any;
  flammableAerosolsChecked = false;

  flammableGases: any;
  flammableGasesChecked = false;

  flammableLiquids: any;
  flammableLiquidsChecked = false;

  flammableSolids: any;
  flammableSolidsChecked = false;

  gasesUnderPressure: any;
  gasesUnderPressureChecked = false;

  oxidizingGases: any;
  oxidizingGasesChecked = false;

  oxidizingLiquids: any;
  oxidizingLiquidsChecked = false;

  oxidizingSolids: any;
  oxidizingSolidsChecked = false;

  organicPeroxides: any;
  organicPeroxidesChecked = false;

  pyrophoricGases: any;
  pyrophoricGasesChecked = false;

  pyrophoricLiquids: any;
  pyrophoricLiquidsChecked = false;

  pyrophoricSolids: any;
  pyrophoricSolidsChecked = false;

  selfHeatingSubstancesMixtures: any;
  selfHeatingSubstancesMixturesChecked = false;

  selfReactiveSubstances: any;
  selfReactiveSubstancesChecked = false;

  simpleAsphyxiants: any;
  simpleAsphyxiantsChecked = false;

  substancesMixturesWaterGas: any;
  substancesMixturesWaterGasChecked = false;

  physicalHazardsNotOtherwiseClassified: any;
  physicalHazardsNotOtherwiseClassifiedChecked = false;

  ngOnInit() {
  }


  onPhysicalStateChecked() {
    this.physicalState = '';
    if (this.physicalStateChecked) {
      this.physicalState = 'PhysicalState';
    }
  }

  onCombustibleDustsChecked() {
    this.combustibleDusts = '';
    if (this.combustibleDustsChecked) {
      this.combustibleDusts = 'CombustibleDusts';
    }
  }

  onCorrosiveToMetalsChecked() {
    this.corrosiveToMetals = '';
    if (this.corrosiveToMetalsChecked) {
      this.corrosiveToMetals = 'CorrosiveToMetals';
    }
  }

  onFlammableAerosolsChecked() {
    this.flammableAerosols = '';
    if (this.flammableAerosolsChecked) {
      this.flammableAerosols = 'FlammableAerosols';
    }
  }

  onFlammableGasesChecked() {
    this.flammableGases = '';
    if (this.flammableGasesChecked) {
      this.flammableGases = 'FlammableGases';
    }
  }

  onFlammableLiquidsChecked() {
    this.flammableLiquids = '';
    if (this.flammableLiquidsChecked) {
      this.flammableLiquids = 'FlammableLiquids';
    }
  }

  onFlammableSolidsChecked() {
    this.flammableSolids = '';
    if (this.flammableSolidsChecked) {
      this.flammableSolids = 'FlammableSolids';
    }
  }

  onGasesUnderPressureChecked() {
    this.gasesUnderPressure = '';
    if (this.gasesUnderPressureChecked) {
      this.gasesUnderPressure = 'GasesUnderPressure';
    }
  }

  onOxidizingGasesChecked() {
    this.oxidizingGases = '';
    if (this.oxidizingGasesChecked) {
      this.oxidizingGases = 'OxidizingGases';
    }
  }

  onOxidizingLiquidsChecked() {
    this.oxidizingLiquids = '';
    if (this.oxidizingLiquidsChecked) {
      this.oxidizingLiquids = 'OxidizingLiquids';
    }
  }

  onOxidizingSolidsChecked() {
    this.oxidizingSolids = '';
    if (this.oxidizingSolidsChecked) {
      this.oxidizingSolids = 'OxidizingSolids';
    }
  }

  onOrganicPeroxidesChecked() {
    this.organicPeroxides = '';
    if (this.organicPeroxidesChecked) {
      this.organicPeroxides = 'OrganicPeroxides';
    }
  }

  onPyrophoricGasesChecked() {
    this.pyrophoricGases = '';
    if (this.pyrophoricGasesChecked) {
      this.pyrophoricGases = 'PyrophoricGases';
    }
  }

  onPyrophoricLiquidsChecked() {
    this.pyrophoricLiquids = '';
    if (this.pyrophoricLiquidsChecked) {
      this.pyrophoricLiquids = 'PyrophoricLiquids';
    }
  }

  onPyrophoricSolidsChecked() {
    this.pyrophoricSolids = '';
    if (this.pyrophoricSolidsChecked) {
      this.pyrophoricSolids = 'PyrophoricSolids';
    }
  }

  onSelfHeatingSubstancesMixturesChecked() {
    this.selfHeatingSubstancesMixtures = '';
    if (this.selfHeatingSubstancesMixturesChecked) {
      this.selfHeatingSubstancesMixtures = 'SelfHeatingSubstancesMix';
    }
  }

  onSelfReactiveSubstancesMixturesChecked() {
    this.selfReactiveSubstances = '';
    if (this.selfReactiveSubstancesChecked) {
      this.selfReactiveSubstances = 'SelfReactiveSubstancesMix';
    }
  }

  onSimpleAsphyxiantsChecked() {
    this.simpleAsphyxiants = '';
    if (this.simpleAsphyxiantsChecked) {
      this.simpleAsphyxiants = 'SimpleAsphxiants';
    }
  }

  onSubstancesMixturesWaterGasChecked() {
    this.substancesMixturesWaterGas = '';
    if (this.substancesMixturesWaterGasChecked) {
      this.substancesMixturesWaterGas = 'SubstancesMixWaterGas';
    }
  }

  onPhysicalHazardsNotOtherwiseClassifiedChecked() {
    this.physicalHazardsNotOtherwiseClassified = '';
    if (this.physicalHazardsNotOtherwiseClassifiedChecked) {
      this.physicalHazardsNotOtherwiseClassified = 'PhysicalHazardsNotOtherwiseClassified';
    }
  }

  onSelectedPhysicalHazardChecked(event) {
    if (event.checked) {
      this.physicalStateChecked = true;
      if (this.physicalStateChecked) {
        this.onPhysicalStateChecked();
      }
      this.combustibleDustsChecked = true;
      if (this.combustibleDustsChecked) {
        this.onCombustibleDustsChecked();
      }
      this.corrosiveToMetalsChecked = true;
      if (this.corrosiveToMetalsChecked) {
        this.onCorrosiveToMetalsChecked();
      }
      this.flammableAerosolsChecked = true;
      if (this.flammableAerosolsChecked) {
        this.onFlammableAerosolsChecked();
      }
      this.flammableGasesChecked = true;
      if (this.flammableGasesChecked) {
        this.onFlammableGasesChecked();
      }
      this.flammableLiquidsChecked = true;
      if (this.flammableLiquidsChecked) {
        this.onFlammableLiquidsChecked();
      }
      this.flammableSolidsChecked = true;
      if (this.flammableSolidsChecked) {
        this.onFlammableSolidsChecked();
      }
      this.gasesUnderPressureChecked = true;
      if (this.gasesUnderPressureChecked) {
        this.onGasesUnderPressureChecked();
      }
      this.oxidizingGasesChecked = true;
      if (this.oxidizingGasesChecked) {
        this.onOxidizingGasesChecked();
      }
      this.oxidizingLiquidsChecked = true;
      if (this.oxidizingLiquidsChecked) {
        this.onOxidizingLiquidsChecked();
      }
      this.oxidizingSolidsChecked = true;
      if (this.oxidizingSolidsChecked) {
        this.onOxidizingSolidsChecked();
      }
      this.organicPeroxidesChecked = true;
      if (this.organicPeroxidesChecked) {
        this.onOrganicPeroxidesChecked();
      }
      this.pyrophoricGasesChecked = true;
      if (this.pyrophoricGasesChecked) {
        this.onPyrophoricGasesChecked();
      }
      this.pyrophoricLiquidsChecked = true;
      if (this.pyrophoricLiquidsChecked) {
        this.onPyrophoricLiquidsChecked();
      }
      this.pyrophoricSolidsChecked = true;
      if (this.pyrophoricSolidsChecked) {
        this.onPyrophoricSolidsChecked();
      }
      this.selfHeatingSubstancesMixturesChecked = true;
      if (this.selfHeatingSubstancesMixturesChecked) {
        this.onSelfHeatingSubstancesMixturesChecked();
      }
      this.selfReactiveSubstancesChecked = true;
      if (this.selfReactiveSubstancesChecked) {
        this.onSelfReactiveSubstancesMixturesChecked();
      }
      this.simpleAsphyxiantsChecked = true;
      if (this.simpleAsphyxiantsChecked) {
        this.onSimpleAsphyxiantsChecked();
      }
      this.substancesMixturesWaterGasChecked = true;
      if (this.substancesMixturesWaterGasChecked) {
        this.onSubstancesMixturesWaterGasChecked();
      }
      this.physicalHazardsNotOtherwiseClassifiedChecked = true;
      if (this.physicalHazardsNotOtherwiseClassifiedChecked) {
        this.onPhysicalHazardsNotOtherwiseClassifiedChecked();
      }
    } else {
      this.physicalStateChecked = false;
      this.physicalState = '';
      this.combustibleDustsChecked = false;
      this.combustibleDusts = '';
      this.corrosiveToMetalsChecked = false;
      this.corrosiveToMetals = '';
      this.flammableAerosolsChecked = false;
      this.flammableAerosols = '';
      this.flammableGasesChecked = false;
      this.flammableGases = '';
      this.flammableLiquidsChecked = false;
      this.flammableLiquids = '';
      this.flammableSolidsChecked = false;
      this.flammableSolids = '';
      this.gasesUnderPressureChecked = false;
      this.gasesUnderPressure = '';
      this.oxidizingGasesChecked = false;
      this.oxidizingGases = '';
      this.oxidizingLiquidsChecked = false;
      this.oxidizingLiquids = '';
      this.oxidizingSolidsChecked = false;
      this.oxidizingSolids = '';
      this.organicPeroxidesChecked = false;
      this.organicPeroxides = '';
      this.pyrophoricGasesChecked = false;
      this.pyrophoricGases = '';
      this.pyrophoricLiquidsChecked = false;
      this.pyrophoricLiquids = '';
      this.pyrophoricSolidsChecked = false;
      this.pyrophoricSolids = '';
      this.selfHeatingSubstancesMixturesChecked = false;
      this.selfHeatingSubstancesMixtures = '';
      this.selfReactiveSubstancesChecked = false;
      this.selfReactiveSubstances = '';
      this.simpleAsphyxiantsChecked = false;
      this.simpleAsphyxiants = '';
      this.substancesMixturesWaterGasChecked = false;
      this.substancesMixturesWaterGas = '';
      this.physicalHazardsNotOtherwiseClassifiedChecked = false;
      this.physicalHazardsNotOtherwiseClassified = '';
    }
  }

  getCheckedValues() {
    const result = [];
    if (this.physicalStateChecked) { result.push(this.physicalState); }
    if (this.combustibleDustsChecked) { result.push(this.combustibleDusts); }
    if (this.corrosiveToMetalsChecked) { result.push(this.corrosiveToMetals); }
    if (this.flammableAerosolsChecked) { result.push(this.flammableAerosols); }
    if (this.flammableGasesChecked) { result.push(this.flammableGases); }
    if (this.flammableLiquidsChecked) { result.push(this.flammableLiquids); }
    if (this.flammableSolidsChecked) { result.push(this.flammableSolids); }
    if (this.gasesUnderPressureChecked) { result.push(this.gasesUnderPressure); }
    if (this.oxidizingGasesChecked) { result.push(this.oxidizingGases); }
    if (this.oxidizingLiquidsChecked) { result.push(this.oxidizingLiquids); }

    if (this.oxidizingSolidsChecked) { result.push(this.oxidizingSolids); }
    if (this.organicPeroxidesChecked) { result.push(this.organicPeroxides); }
    if (this.pyrophoricGasesChecked) { result.push(this.pyrophoricGases); }
    if (this.pyrophoricLiquidsChecked) { result.push(this.pyrophoricLiquids); }
    if (this.pyrophoricSolidsChecked) { result.push(this.pyrophoricSolids); }
    if (this.selfHeatingSubstancesMixturesChecked) { result.push(this.selfHeatingSubstancesMixtures); }
    if (this.selfReactiveSubstancesChecked) { result.push(this.selfReactiveSubstances); }
    if (this.simpleAsphyxiantsChecked) { result.push(this.simpleAsphyxiants); }
    if (this.substancesMixturesWaterGasChecked) { result.push(this.substancesMixturesWaterGas); }
    if (this.physicalHazardsNotOtherwiseClassifiedChecked) { result.push(this.physicalHazardsNotOtherwiseClassified); }
    return result;
  }
}
